import { axiosInstance } from "api/axios.instance"

class ReleaseInformationService {
	async getReleases() {
		return axiosInstance.get("releases/")
	}
}

export default new ReleaseInformationService()
